import React from 'react';
import OCRComponent from '../components/OCRComponent';

const OCRPage: React.FC = () => {
  const handleTextExtracted = (text: string) => {
    console.log('Extracted text:', text);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>OCR 文字识别</h1>
      <OCRComponent onTextExtracted={handleTextExtracted} />
      
      <div style={{ 
        marginTop: '40px', 
        padding: '20px', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '8px' 
      }}>
        <h3>说明:</h3>
        <ul>
          <li>支持中英文混合识别</li>
          <li>支持常见图片格式 (JPG, PNG, GIF, WebP)</li>
          <li>识别结果可以直接编辑和复制</li>
          <li>处理过程有进度显示</li>
        </ul>
      </div>
    </div>
  );
};

export default OCRPage;